import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-playbook-actions-cell',
  templateUrl: './playbook-actions-cell.component.html',
  styleUrls: ['./playbook-actions-cell.component.scss'],
})
export class PlaybookActionsCellComponent implements OnInit {
  @Input() public actions: string[] = [];

  public visibleActions: string[] = [];
  public remainingActions: string[] = [];
  public hasMoreActions = false;
  public remainingCount = 0;
  public tooltipText = '';

  ngOnInit(): void {
    if (this.actions.length > 3) {
      this.visibleActions = this.actions.slice(0, 3);
      this.remainingActions = this.actions.slice(3);
      this.hasMoreActions = true;
      this.remainingCount = this.remainingActions.length;
      this.tooltipText = this.remainingActions.join('\n');
    } else {
      this.visibleActions = this.actions;
      this.hasMoreActions = false;
    }
  }
}
